<template>
	<section>
		<header-simple :title="$t('labels.profile.medical_information')" :subtitle="$t('Personal information about the patient.')">
			<!-- <action-button @click="addContact" :title="$t('Add disease')" /> -->
		</header-simple>

		<grid>
			<grid-item ref="list" v-for="item in getDiseases(patient)" :key="item.id" :loading="contactLoading.find(e => e.id == item.id) != undefined" :title="$t('Disease')" :value="getDiseaseNameById(item.name_id).name">
				<action-group>
					<!-- <action-group-item-button @click="editItem(item)" :title="$t('buttons.general.edit')" /> -->
					<action-group-item-button @click="copyItem(item)" :title="$t('Copy')" />
					<!-- <action-group-item-button @click="deleteItem(item)" :title="$t('buttons.general.delete')" /> -->
				</action-group>
			</grid-item>
		</grid>

		<watch-profile-medical-information-diseases-form v-if="modalDiseaseForm.open" :params="modalDiseaseForm.params" :user_uid="user_uid" :watch_id="watch_id" @close="closeModal('modalDiseaseForm', arguments)"/>
	</section>
</template>

<script>
import ActionGroup from '@/modules/ui/ActionGroup'
import ActionGroupItemButton from '@/modules/ui/ActionGroupItemButton'
import HeaderSimple from '@/modules/ui/HeaderSimple'
import ActionButton from '@/modules/ui/ActionButton'
import Grid from '@/modules/ui/Grid'
import GridItem from '@/modules/ui/GridItem'
import { mapGetters, mapActions } from 'vuex'
import WatchProfileMedicalInformationDiseasesForm from '@/components/watch/profile/watchProfile/WatchProfileMedicalInformationDiseasesForm'
export default {
	name: 'watch-profile-medical-information',
	components: {
		WatchProfileMedicalInformationDiseasesForm,
		ActionGroup,
		ActionGroupItemButton,
		HeaderSimple,
		ActionButton,
		Grid,
		GridItem
	},
	props: [
		'user_uid',
		'watch_id'
	],
	data() {
		return {
			patient: {},
			contacts: [],
			contactLoading: [],
			modalDiseaseForm: {
				open: false,
				params: {}
			},
		}
	},
	methods: {
		openModal (modal, params = {}) {
			this[modal].open = true
			this[modal].params = params
		},
		closeModal (modal, args) {
			this[modal].open = false
			this[modal].params = {}
		},
		addContact () {
			this.openModal('modalContactForm', { action: 'add' })
		},
		editItem (item) {
			const id = item.id
			this.openModal('modalContactForm', { action: 'edit', id })
		},
		copyItem (item) {
			const id = item.id
			const dummyId = "contact_id_"+ id
			const dummy = document.createElement("input")

			document.body.appendChild(dummy)
			dummy.setAttribute("id", dummyId)
			document.getElementById(dummyId).value = this.getDiseaseNameById(item.name_id).name
			dummy.select()
			dummy.setSelectionRange(0, 99999)
			document.execCommand("copy")
			document.body.removeChild(dummy)

			this.$root.$emit('add-floating-box', { type: 'info', title: 'Copy', message: 'Contact copy to clipboard with success.' })
		},
		async deleteItem(item) {
			if (confirm('Delete?')) {
				this.contactLoading.push(item)
				try
				{
					await this.contactDelete({ refThis: this, item })
					this.$root.$emit('add-floating-box', { type: 'success', title: 'Success', message: 'Contact delete with success.' })
				}
				catch (ex)
				{
					this.$root.$emit('add-floating-box', { type: 'error', title: 'Error', message: 'Issue when try to delete contact. Try again please.' })
				}
				this.contactLoading = this.contactLoading.filter(e => e.id !== item.id)
			}
		},
		...mapActions({
			contactDelete: 'CONTACT_DELETE'
		})
	},
	computed: {
		...mapGetters({
			getPatient: 'PATIENT',
			getDiseases: 'PATIENTS_DISEASES',
			getDiseaseNameById: 'DISEASE_NAME_BY_ID',
		})
	},
	created () {
		this.patient = this.getPatient(parseInt(this.watch_id))
	}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/watch/profile/watchProfile/WatchProfileMedicalInformation.vue